import { render, staticRenderFns } from "./AddAlphaGroupModal.vue?vue&type=template&id=7238cbb7"
import script from "./AddAlphaGroupModal.vue?vue&type=script&lang=js"
export * from "./AddAlphaGroupModal.vue?vue&type=script&lang=js"
import style0 from "./AddAlphaGroupModal.vue?vue&type=style&index=0&id=7238cbb7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports